import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/services/auth.guard';
import { SettingsComponent } from './modules/settings/settings.component';
import { LayoutComponent } from './layout/layout/layout.component';
import { Routing } from './pages/routing';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./modules/password-reset/password-reset.module').then(
        (m) => m.PasswordResetModule
      ),
  },
  {
    path: 'eager-activation',
    loadChildren: () =>
      import('./modules/eager-activation/eager-activation.module').then(
        (m) => m.EagerActivationModule
      ),
  },
  {
    path: '',
    /*canActivate: [AuthGuard],*/
    component: LayoutComponent,
    children: Routing
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      ...Routing,
      {
        path: 'invites',
        loadChildren: () => import('./modules/invitesmodule/invites.module').then(m => m.InvitesModule)
      },
      { path: '', redirectTo: 'invites', pathMatch: 'full' } // opcional
    ]
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
